// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../duck';
import CheckoutStep from '../components/CheckoutStep';

import { push } from 'react-router-redux';

import { actions as AlertActions } from '../../../alert/duck';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    locale: state.locale,
    localValues: state.localValues,
    isFetchingAddresses: state.newOrder.checkoutStep.isFetchingAddresses,
    fetchAddressesError: state.newOrder.checkoutStep.fetchAddressesError,
    addresses: state.newOrder.checkoutStep.addresses,
    isFetchingPaymentMethods: state.newOrder.checkoutStep.isFetchingPaymentMethods,
    fetchPaymentMethodsError: state.newOrder.checkoutStep.fetchPaymentMethodsError,
    paymentMethods: state.newOrder.checkoutStep.paymentMethods,
    order: state.newOrder.checkoutStep.order,
    isFetchingOrder: state.newOrder.checkoutStep.isFetchingOrder,
    fetchOrderError: state.newOrder.checkoutStep.fetchOrderError,
    isCreatingOrderAndToken: state.newOrder.checkoutStep.isCreatingOrderAndToken,
    createOrderAndTokenError: state.newOrder.checkoutStep.createOrderAndTokenError,
    isUpdatingOrderPaymentMethod: state.newOrder.checkoutStep.isUpdatingOrderPaymentMethod,
    updateOrderPaymentMethodError: state.newOrder.checkoutStep.updateOrderPaymentMethodError,
    bag: state.bag.bag,
    isPostingPaymentExecute: state.newOrder.checkoutStep.isPostingPaymentExecute,
    paymentExecuteSuccess: state.newOrder.checkoutStep.paymentExecuteSuccess,
    paymentExecuteError: state.newOrder.checkoutStep.paymentExecuteError,
    isFetchingCart: state.shoppingCart.isFetchingCart,
    shoppingCart: state.shoppingCart.shoppingCart,
    importMethod: state.newOrder.checkoutStep.importMethod,
    forecast: state.newOrder.checkoutStep.forecast,
    selectedIndex: state.newOrder.checkoutStep.selectedIndex,
    appliedCoupon: state.newOrder.checkoutStep.appliedCoupon,
    paymentExecuteUIError: state.newOrder.checkoutStep.paymentExecuteUIError,
    paymentGetLibraryError: state.newOrder.checkoutStep.paymentGetLibraryError,
    rootState: state,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    ...bindActionCreators({
      ...actions,
      ...AlertActions,
      goToRedirect: (route: string) => push(route),
    }, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutStep);



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/containers/CheckoutStepContainer.jsx